import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader, TranslocoLoaderData } from '@jsverse/transloco';
import { Observable } from 'rxjs';

import { I18N_VERSION } from './i18n-version';

/**
 * Loads translation JSON over HttpClient. Global files live at
 * assets/i18n/{lang}.json; scoped feature files at assets/i18n/{scope}/{lang}.json.
 * Transloco passes the scope in `data`, so the same loader serves both.
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string, data?: TranslocoLoaderData): Observable<Translation> {
    const path = data?.scope ? `${data.scope}/${lang}` : lang;
    // ?v=<content hash> busts CDN/browser caches on translation changes; the
    // files are served with stable names and immutable caching (nginx.conf).
    return this.http.get<Translation>(`assets/i18n/${path}.json?v=${I18N_VERSION}`);
  }
}
